import { Link } from 'react-router'

import type { ImportCustomerResponse } from '@/models/qa'

function DetailList({ summary, lines, tone }: { summary: string; lines: string[]; tone: string }) {
  if (lines.length === 0) return null
  return (
    <details>
      <summary className={`cursor-pointer ${tone}`}>{summary}</summary>
      <ul className="text-muted-foreground mt-1 list-disc pl-5">
        {lines.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </details>
  )
}

/** What a customer import actually did — created, updated, merged, and file transfers. */
export function ImportCustomerResult({ result }: { result: ImportCustomerResponse }) {
  return (
    <div className="flex flex-col gap-2 text-sm">
      <p className="text-green-600">
        Imported {result.imported} record(s) — {result.created} new, {result.updated} updated
        {result.sourceEnv && ` from ${result.sourceEnv}`}.{' '}
        {result.orgs.map((org) => (
          <Link key={org.id} to={`/insure/internal/customers/${org.id}`} className="underline">
            Open {org.name}
          </Link>
        ))}
      </p>
      {(result.filesFetched > 0 || result.filesAlreadyPresent > 0) && (
        <p className="text-green-600">
          Fetched {result.filesFetched} document file(s); {result.filesAlreadyPresent} already here.
        </p>
      )}
      <DetailList
        summary={`${result.merged.length} record(s) merged into rows this environment already had`}
        lines={result.merged}
        tone="text-amber-600"
      />
      <DetailList
        summary={`${result.dropped.length} reference(s) and row(s) missing here were dropped`}
        lines={result.dropped}
        tone="text-amber-600"
      />
      <DetailList
        summary={`${result.fileErrors.length} document file(s) could not be fetched — download links expire an hour after export`}
        lines={result.fileErrors}
        tone="text-red-600"
      />
    </div>
  )
}
